<template>
  <div>
   
    <v-card-title>
      <!-- <h2>Vehicle Expiry Details</h2> -->
      <v-spacer></v-spacer>

      <!-- <v-btn class="mx-0" color="info" title="Download" @click="downloadFIle">
        <v-icon color="white">cloud_download</v-icon>
      </v-btn>   -->

      <v-btn color="error" @click="previous" title="Back">
          <v-icon>arrow_back_ios</v-icon>Back
        </v-btn>

    </v-card-title>

     <table width="100%" class="tblClass">
      <tbody>     
        <tr>
          <th colspan="4" style="font-weight:bold; font-size:20px; padding:10px 0px;">Vehicle Expiry  Details</th>
        </tr>
        <tr>
          <th>Vehicle Name</th>
          <td colspan="3" style="font-weight:bold; padding-left:8px;">{{vehicleInfo.vehicle_name}}</td>
        </tr>
        <tr>
          <td colspan="4">&nbsp;</td>
        </tr>

        <tr class="textCenter">          
          <th>Model No.</th> 
          <th>Engine No.</th> 
          <th>Registration.</th> 
        </tr>

        <tr class="textCenter">          
          <td>{{vehicleInfo.model_no}}</td> 
          <td>{{vehicleInfo.engine_no}}</td> 
          <td>{{vehicleInfo.registration}}</td> 
        </tr>


        <tr class="textCenter">
          <th>Fitness Issue Date</th> 
          <th>Fitness Expiry Date</th>
          <th>Insurance Issue Date</th> 
         
        </tr>
        <tr class="textCenter">

          <td>{{vehicleInfo.fitness_issue_date}}</td> 
          <td>
            <span v-if="vehicleMeta.fit_days <=30" class="in-active">{{vehicleInfo.fitness_expire_date}}</span> 
            <span v-else class="active">{{vehicleInfo.fitness_expire_date}}</span></td> 
          <td>{{vehicleInfo.insurance_issue_date}}</td> 
        </tr>


        <tr class="textCenter">
          <th>Insurance Expiry Date</th> 
          <th>Tax Issue Date </th>
          <th>Tax Expiry Date</th> 
         
        </tr>
        <tr class="textCenter">
          <td>
            <span v-if="vehicleMeta.ins_days <=30" class="in-active">{{vehicleInfo.insurance_expire_date}}</span> 
            <span v-else class="active">{{vehicleInfo.insurance_expire_date}}</span> </td> 
          <td>{{vehicleInfo.tax_issue_date}}</td> 
          <td><span v-if="vehicleMeta.tax_days <=30" class="in-active">{{vehicleInfo.tax_expire_date}}</span> 
            <span v-else class="active">{{vehicleInfo.tax_expire_date}}</span></td> 
         
        </tr>

        <tr class="textCenter">
          <th colspan="3">Remarks</th> 
         
          
        </tr>
        <tr class="textCenter">
          <td colspan="3"></td>
        
          
        </tr>
            

      </tbody>
    </table>
    <br><br>
    <br><br>
 </div>
</template>
<script>
const commonService = require('../../../services/common.service');
import Axios from "axios";
import ServerPath from '../../../server-path/server-path';

export default {

  data: () => ({
    valid: true,    
    vehicleMeta:[],
    vehicleInfo: []

  }),

  created() {
   let vehicleInfo = sessionStorage.getItem("vehicleInfo")
   this.vehicleMeta= JSON.parse(vehicleInfo)
   commonService.getAllDataById(this.vehicleMeta.id,'vehicle_info').then(res => {                                    
        this.vehicleInfo = res.data
        console.log(this.vehicleInfo, this.vehicleMeta)
    });

  },

  
  methods: {

    satusName(statusId){
    let status_list = [
      { id: "1", name: "Plan" },
      { id: "2", name: "Execute" },
      { id: "3", name: "Revision" },
      { id: "4", name: "Merge" },
      { id: "5", name: "Split" },
      { id: "6", name: "Close" },
      { id: "7", name: "Terminate" },
      { id: "8", name: "Procured" },
    ];
    if (statusId) {
      return status_list.filter(function(a) {
        return a.id == statusId;
      })[0].name;
      
      //console.log('status_list', status_list)
    }

    },

    downloadFIle(){

      let query_Data2 = this.queryData2;
        
        (query_Data2.trainInfoId = sessionStorage.getItem("trainInfoId"))
        

      let parameters = new URLSearchParams({ ...query_Data2}).toString();
      let route = ServerPath.serverPath+'/training-details-pdf?'+parameters;
      window.open(route, '_blank');
    },

    previous(){
      this.$router.push('/administration/vehicle-entry') 
    }
  }
};
</script>

<style scoped>
.tblClass{
  border-collapse: collapse;
}
.tblClass tr th,
.tblClass tr td{
  border:1px solid #CCC;
  padding:8px 0px;
}
.textCenter tr th,
.textCenter tr td,
.textCenter{
  text-align: center;  
}
</style>


// WEBPACK FOOTER //
// src/components/administration/vehicle_info/vehicle_expiry_details.vue